if (!customElements.get('before-after')) {
  class BeforeAfter extends HTMLElement {
    constructor() {
      super();
      this.isDragging = false;
      this.toggleDragging = this.toggleDragging.bind(this);
      this.resizeSlides = this.resizeSlides.bind(this);
    }

    connectedCallback() {
      this.before = this.querySelector('.before');
      this.after = this.querySelector('.after');
      this.range = this.querySelector('.slider-bar');

      if (!this.before || !this.after || !this.range) return;

      // Mouse events
      this.addEventListener('mousedown', this.toggleDragging);
      this.addEventListener('mouseup', this.toggleDragging);
      this.addEventListener('mousemove', this.resizeSlides);
      this.addEventListener('mouseleave', () => {
        this.isDragging = false;
      });

      // Touch events
      this.addEventListener('touchstart', (e) => {
        this.isDragging = true;
        e.preventDefault();
      }, { passive: false });
      this.addEventListener('touchend', () => {
        this.isDragging = false;
      });
      this.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        e.preventDefault();
        const touch = e.touches[0];
        this.handleResize(touch.clientX);
      }, { passive: false });
    }

    toggleDragging(e) {
      this.isDragging = e.type === 'mousedown' ? !this.isDragging : this.isDragging;
    }

    resizeSlides(e) {
      if (!this.isDragging) return;

      this.handleResize(e.clientX);
    }

    handleResize(clientX) {
      const rect = this.getBoundingClientRect();
      let offsetX = clientX - rect.left;
      offsetX = Math.max(0, Math.min(offsetX, rect.width));

      const percentage = (offsetX / rect.width) * 100;
      this.range.style.left = `${percentage}%`;

      this.after.style.clipPath = `inset(0 0 0 ${percentage}%)`;
    }
  }

  customElements.define('before-after', BeforeAfter);
}


if (!customElements.get('before-after-container')) {
  class BeforeAfterContainer extends HTMLElement {
    constructor() {
      super();
      this.handleSelectTab = this.handleSelectTab.bind(this);
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('.ba-tab');
      this.selectField = this.querySelector('#ba-tabs');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleSelectTab);
      });

      if (!this.selectField) return;

      this.selectField.addEventListener('change', (e) => {
        const target = e.target;
        const targetNumber = target.value;

        this.querySelector('.ba-tab.ba-tab-active')?.classList.remove('ba-tab-active');
        this.querySelector(`.ba-tab[data-for="${targetNumber}"]`).classList.add('ba-tab-active');

        this.querySelector('.ba-tab-content.ba-tab-content-active')?.classList.remove('ba-tab-content-active');
        this.querySelector(`.ba-tab-content[data-for="${targetNumber}"]`).classList.add('ba-tab-content-active');
      })
    }

    handleSelectTab(e) {
      this.querySelector('.ba-tab.ba-tab-active')?.classList.remove('ba-tab-active');
      const target = e.target.closest('.ba-tab');
      
      if (target) {
        target.classList.add('ba-tab-active');
        const targetNumber = target.dataset.for;

        this.querySelector('.ba-tab-content.ba-tab-content-active')?.classList.remove('ba-tab-content-active');
        this.querySelector(`.ba-tab-content[data-for="${targetNumber}"]`).classList.add('ba-tab-content-active');
      }
    }
  }

  customElements.define('before-after-container', BeforeAfterContainer);
}
